import React, { useState } from 'react';
import { uniq } from 'underscore';

import ConfigurationForm from './configuration-form';
import Steps from './steps';
import UploadTopics from './upload-topics';
import ManageTopics from './manage-topics';

export interface WorkdayAuthConfig {
  clientId: string;
  clientSecret: string;
  authUrl: string;
  trackingUrl: string;
  contentUrl: string;
}

export type WorkdayLearnConfig = WorkdayAuthConfig & {
  topics: string[];
  defaultTopics: string[];
};
interface ConfigurationProps {
  onSubmit: (data: WorkdayAuthConfig) => Promise<any>;
  closeModal: (data: WorkdayLearnConfig) => void;
}

const WorkdayConfiguration: React.FC<ConfigurationProps> = ({ onSubmit, closeModal }) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [uploadedTopics, setUploadedTopics] = useState<string[]>([]);
  const [workdayConfig, setWorkdayConfig] = useState<WorkdayAuthConfig | null>(null);

  const handleConfigureWorkday = async (data: WorkdayAuthConfig) => {
    const result = await onSubmit(data);
    setWorkdayConfig(data);
    if (!result) return false;
    setCurrentStep(2);
    return true;
  };

  const handleAddNewTopics = (params: { topics: string[], defaultTopics?: string[] }) => {
    const newTopics = uniq([...uploadedTopics, ...params.topics]);
    setUploadedTopics(newTopics);
    closeModal({
      ...params,
      defaultTopics: params.defaultTopics ?? [],
      ...workdayConfig,
    });
  };

  return (
    <div className='d-flex flex-column justify-content-center align-items-center px-4 pb-4'>
      <Steps currentStep={currentStep} />

      {currentStep === 1 && (
        <ConfigurationForm
          onSubmit={handleConfigureWorkday}
        />
      )}
      {currentStep === 2 && (
        <>
          {!uploadedTopics.length ? (
            <UploadTopics onConfirmTopics={(topics) => setUploadedTopics(topics)} />
          ) : (
            <ManageTopics
              topics={uploadedTopics}
              onAddTopics={(params) => handleAddNewTopics(params)}
              isEditing={false}
            />
          )}
        </>
      )}
    </div>
  );
};

export default WorkdayConfiguration;
